/*
 * Author: Roger
 * File Created: Monday, 24-08-05 04:18 pm
 * Last Modified: Monday, 25-03-17 03:18 pm, by Harper Yan
 */
import {
  dialogClasses,
  drawerClasses,
  styled,
  Typography,
} from '@mui/material';
import { Icon } from '@ucard/ds/Icon';
import { DrawerDialog } from '@ucard/ds/message/dialog/templates';

export const StyledDialog = styled(DrawerDialog)(() => ({
  [`& .${dialogClasses.paper},.${drawerClasses.paper}`]: {
    padding: '0',
    overflow: 'hidden',
  },

  '.drawer-close,.dialog-close': {
    marginTop: '20px',
    right: '20px',
  },
}));

export const StyledWelcomeText = styled(Typography)(() => ({
  fontSize: '24px',
  fontWeight: 500,
  color: '#FFF',
}));

export const MenuItemText = styled(Typography)({
  color: '#707A8A',
  fontSize: '14px',
  fontWeight: 400,
  marginRight: '4px',
});

interface StyledIconProps {
  name: string;
}
export const StyledIcon = styled(Icon)<StyledIconProps>(({ name }) => ({
  fontSize: '20px',
  color: '#707A8A',
  marginRight: name === 'ArrowForward' ? '0' : '8px',
}));

export const StyledSubTitleText = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: 500,
  color: '#707A8A',
}));
